<div class="app-layout">
  <!-- Header component if you have one -->
  <app-header *ngIf="authService.isLoggedIn()" ></app-header>

  <app-notification></app-notification>
<!-- <app-loading-spinner></app-loading-spinner> -->

  <div class="content-container">
    <!-- Sidenav component - now using ViewChild instead of constructor injection -->
    <app-sidenav *ngIf="authService.isLoggedIn() && !isLoginPage && (!isDashboard || flag)" 
    [ngClass]="{'sidenav-loading': sidenavLoading}">
    </app-sidenav>

    <!-- Main content with router outlet -->
    <main [ngClass]="{'with-padding': !isLoginPage}" class="main-content">
      <router-outlet (activate)="onRouteActivate($event)"></router-outlet>
    </main>
  </div>
  <app-footer *ngIf="pageDataService.showFooter$ | async"></app-footer>
  <app-chatbot *ngIf="authService.isLoggedIn() && !isLoginPage"></app-chatbot>
</div>
